__webpack_require__.p = "/aitd2-cards/";